/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryDetailRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryDetailRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryDetailRequest>): ComplianceAssessmentSummaryDetailRequest {
        let obj = Object.assign(new ComplianceAssessmentSummaryDetailRequest(), model);
        ComplianceAssessmentSummaryDetailRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryDetailRequest>): ComplianceAssessmentSummaryDetailRequest {
        if (!model) return null;
        return ComplianceAssessmentSummaryDetailRequest.newInstance(<ComplianceAssessmentSummaryDetailRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryDetailRequest) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryDetailRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryDetailRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryDetailRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    tenant_ids: Array<string>;

    /**
     * Optional list of service account IDs to narrow the filter response. Omit to retrieve all accounts under the tenant.
     */
    service_account_ids: Array<string>;

    /**
     * Return every standard that has a latest assessment, including standards without violated policies. Defaults to false, which returns only standards with violated policies.
     */
    include_all_standards: boolean;

}
